import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, Input, output, input, ChangeDetectionStrategy } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-walkthrough-dialog-footer',
  imports: [ButtonComponent, IconComponent, NgTemplateOutlet],
  templateUrl: './walkthrough-dialog-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './walkthrough-dialog-footer.component.less',
})
export class WalkthroughDialogFooterComponent {
  private readonly i18n = inject(I18nService);

  public readonly currentStep = input<number>(undefined!);

  public readonly ofText = input<string>(undefined!);
  public readonly ctaText = input<string>(undefined!);
  public readonly closeText = input<string>(undefined!);
  public readonly skipText = input<string>(undefined!);
  public readonly displayCtaOnly = input<boolean>(false);
  public readonly showStepCounter = input<boolean>(true);
  public readonly showSkipButton = input<boolean>(false);
  public readonly learnMoreText = input<string>(this.i18n.translate('app.common.learn_more'));
  @Input() public stepsTotal: number;
  @Input() public ctaIcon?: IconName = undefined;
  @Input() public closeIcon: IconName | undefined;
  @Input() public dialogHelpArticle: string;

  public cancel = output<void>();
  public start = output<void>();
}
